import { render, staticRenderFns } from "./list-card.vue?vue&type=template&id=1c431b02&"
import script from "./list-card.vue?vue&type=script&lang=ts&"
export * from "./list-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports